import { FormattedRpServiceConfigurationScoreModifier } from "@idw-types/data/rp-service-configuration/rp-service-configuration-score";
import { safelyParseIntFromString } from "@utils/string-util";

export const getAssertionScoreModifierPoints = (
    assertionScoreModifiers: FormattedRpServiceConfigurationScoreModifier[]
) => {
    const points = assertionScoreModifiers.reduce((sum, assertion) => {
        return (
            sum +
            Math.max(
                safelyParseIntFromString(assertion.passScore),
                safelyParseIntFromString(assertion.closeScore),
                safelyParseIntFromString(assertion.partialScore),
                safelyParseIntFromString(assertion.unverifiedScore),
                safelyParseIntFromString(assertion.failScore)
            )
        );
    }, 0);
    return points;
};
